"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bookingServicesRootSaga = bookingServicesRootSaga;
var _effects = require("redux-saga/effects");
var _ramda = require("ramda");
var _jsonApi = require("@otpusk/json-api");
var _actions = require("@otpusk/apisearch-toolbox/dist/services/actions");
var _selectors = require("@otpusk/apisearch-toolbox/dist/services/selectors");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _selectors2 = require("@otpusk/apisearch-toolbox/dist/queries/selectors");
var _helpers = require("@otpusk/apisearch-toolbox/dist/services/helpers");
var _selectors3 = require("@otpusk/apisearch-toolbox/dist/offers/selectors");
var _actions2 = require("../../../../../../../bus/ui/actions");
var _selectors4 = require("../../../../../../../bus/auth/selectors");
var _config = require("../../../../../../../services/config");
var _selectors5 = require("../../../store/selectors");
var _actions3 = require("./actions");
var _helpers2 = require("./helpers");
var _constants = require("./constants");
var _selectors6 = require("./selectors");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(fetchBookingServicesAsDefault),
  _marked2 = /*#__PURE__*/_regeneratorRuntime().mark(fetchBookingServices),
  _marked3 = /*#__PURE__*/_regeneratorRuntime().mark(setIncludedServicesAsActive),
  _marked4 = /*#__PURE__*/_regeneratorRuntime().mark(bookingServicesRootSaga);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i.return && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, catch: function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function updateBookingServicesSaga(_ref) {
  var payload = _ref.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var offerID, queryID, isShow;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          offerID = payload.offerID, queryID = payload.queryID;
          _context.next = 3;
          return (0, _effects.select)(_selectors6.getIsShow);
        case 3:
          isShow = _context.sent;
          if (!isShow) {
            _context.next = 9;
            break;
          }
          _context.next = 7;
          return (0, _effects.put)((0, _actions3.hideBookingServices)(offerID, queryID));
        case 7:
          _context.next = 9;
          return (0, _effects.put)((0, _actions3.showBookingServices)(offerID, queryID));
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })();
}
function fetchBookingServicesAsDefault(offerID, currencyCode) {
  var _yield$race, _yield$race2, fail;
  return _regeneratorRuntime().wrap(function fetchBookingServicesAsDefault$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.next = 2;
        return (0, _effects.put)(_actions.servicesActions.getBookingServices(offerID, currencyCode));
      case 2:
        _context2.next = 4;
        return (0, _effects.race)([(0, _effects.take)(_actions.servicesActions.setBookingServices), (0, _effects.take)(_actions.servicesActions.getBookingServicesFail)]);
      case 4:
        _yield$race = _context2.sent;
        _yield$race2 = _slicedToArray(_yield$race, 2);
        fail = _yield$race2[1];
        if (!fail) {
          _context2.next = 9;
          break;
        }
        throw fail.payload;
      case 9:
      case "end":
        return _context2.stop();
    }
  }, _marked);
}
function fetchBookingServices(offerID, currencyCode) {
  var transport, services;
  return _regeneratorRuntime().wrap(function fetchBookingServices$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        transport = (0, _config.getOnGetBookingServices)();
        if (!transport) {
          _context3.next = 7;
          break;
        }
        _context3.next = 4;
        return (0, _effects.call)(transport, offerID, currencyCode);
      case 4:
        services = _context3.sent;
        _context3.next = 7;
        return (0, _effects.put)(_actions.servicesActions.setBookingServices((0, _helpers.createBookingServicesKey)(offerID, currencyCode), services));
      case 7:
      case "end":
        return _context3.stop();
    }
  }, _marked2);
}
function setIncludedServicesAsActive(offerID, queryID) {
  var currency, includedBookingServices;
  return _regeneratorRuntime().wrap(function setIncludedServicesAsActive$(_context4) {
    while (1) switch (_context4.prev = _context4.next) {
      case 0:
        _context4.next = 2;
        return (0, _effects.select)(function (state) {
          return (0, _selectors2.getQueryParam)(state, {
            paramName: _fn.QUERY_PARAMS.CURRENCY,
            queryID: queryID
          });
        });
      case 2:
        currency = _context4.sent;
        _context4.next = 5;
        return (0, _effects.select)(function (state) {
          return (0, _ramda.pipe)(_selectors.getBookingServicesByOffer, (0, _ramda.filter)(function (_ref2) {
            var included = _ref2.included;
            return included;
          }), (0, _ramda.map)(function (_ref3) {
            var id = _ref3.id,
              enabledTourists = _ref3.enabledTourists;
            return [id, (0, _helpers2.mapTourists2Service)(enabledTourists)];
          }), _ramda.fromPairs)(state, {
            currency: currency,
            offerID: offerID
          });
        });
      case 5:
        includedBookingServices = _context4.sent;
        if ((0, _ramda.isEmpty)(includedBookingServices)) {
          _context4.next = 11;
          break;
        }
        _context4.next = 9;
        return (0, _effects.put)((0, _actions3.setActiveServices)(includedBookingServices));
      case 9:
        _context4.next = 11;
        return (0, _effects.put)((0, _actions3.setShouldRecalculatePrice)(true));
      case 11:
      case "end":
        return _context4.stop();
    }
  }, _marked3);
}
function onShowBookingServicesSaga(_ref4) {
  var payload = _ref4.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var offerID, queryID, currencyCode, _yield$select, hasOwnBookingServices, isNeedForceApplyRecalculate;
    return _regeneratorRuntime().wrap(function _callee2$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          offerID = payload.offerID, queryID = payload.queryID;
          _context5.next = 3;
          return (0, _effects.put)((0, _actions2.register)(_constants.FETCH_BOOKING_SERVICES_DATA, {
            completed: false,
            loading: true,
            error: false
          }));
        case 3:
          _context5.next = 5;
          return (0, _effects.select)(function (state) {
            return (0, _selectors2.getQueryParam)(state, {
              paramName: _fn.QUERY_PARAMS.CURRENCY,
              queryID: queryID
            });
          });
        case 5:
          currencyCode = _context5.sent;
          _context5.next = 8;
          return (0, _effects.select)(_selectors5.getBookingOperator);
        case 8:
          _yield$select = _context5.sent;
          hasOwnBookingServices = _yield$select.hasOwnBookingServices;
          _context5.prev = 10;
          _context5.next = 13;
          return (0, _effects.call)(hasOwnBookingServices ? fetchBookingServices : fetchBookingServicesAsDefault, offerID, currencyCode);
        case 13:
          _context5.next = 15;
          return (0, _effects.call)(setIncludedServicesAsActive, offerID, queryID);
        case 15:
          _context5.next = 17;
          return (0, _effects.select)(function (state) {
            return (0, _ramda.keys)((0, _selectors6.getActiveServices)(state)).length;
          });
        case 17:
          isNeedForceApplyRecalculate = _context5.sent;
          if (!isNeedForceApplyRecalculate) {
            _context5.next = 21;
            break;
          }
          _context5.next = 21;
          return (0, _effects.put)((0, _actions3.forceApplyRecalculate)());
        case 21:
          _context5.next = 23;
          return (0, _effects.put)((0, _actions3.setIsShow)(true));
        case 23:
          _context5.next = 29;
          break;
        case 25:
          _context5.prev = 25;
          _context5.t0 = _context5["catch"](10);
          _context5.next = 29;
          return (0, _effects.put)((0, _actions2.update)(_constants.FETCH_BOOKING_SERVICES_DATA, {
            error: true
          }));
        case 29:
          _context5.prev = 29;
          _context5.next = 32;
          return (0, _effects.put)((0, _actions2.update)(_constants.FETCH_BOOKING_SERVICES_DATA, {
            completed: true,
            loading: false
          }));
        case 32:
          return _context5.finish(29);
        case 33:
        case "end":
          return _context5.stop();
      }
    }, _callee2, null, [[10, 25, 29, 33]]);
  })();
}
function onHideBookingServicesSaga(_ref5) {
  var payload = _ref5.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var offerID, queryID, currencyCode;
    return _regeneratorRuntime().wrap(function _callee3$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          offerID = payload.offerID, queryID = payload.queryID;
          _context6.next = 3;
          return (0, _effects.select)(function (state) {
            return (0, _selectors2.getQueryParam)(state, {
              paramName: _fn.QUERY_PARAMS.CURRENCY,
              queryID: queryID
            });
          });
        case 3:
          currencyCode = _context6.sent;
          _context6.next = 6;
          return (0, _effects.put)((0, _actions2.unRegister)(_constants.FETCH_BOOKING_SERVICES_DATA));
        case 6:
          _context6.next = 8;
          return (0, _effects.put)(_actions.servicesActions.resetBookingServices(offerID, currencyCode));
        case 8:
          _context6.next = 10;
          return (0, _effects.put)((0, _actions3.setIsShow)(false));
        case 10:
        case "end":
          return _context6.stop();
      }
    }, _callee3);
  })();
}
function recalculateOfferPriceByDefault(_ref6) {
  var services = _ref6.services,
    offerID = _ref6.offerID,
    currency = _ref6.currency;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var lang, tokenAsObject, body, query, _yield$call, price, rate;
    return _regeneratorRuntime().wrap(function _callee4$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.select)(_selectors4.getLang);
        case 2:
          lang = _context7.sent;
          _context7.next = 5;
          return (0, _effects.select)(_selectors4.getToken);
        case 5:
          tokenAsObject = _context7.sent;
          body = JSON.stringify({
            services: (0, _ramda.map)(function (service) {
              return {
                id: service.id,
                name: service.name,
                number: service.activeCountOfService
              };
            }, services)
          });
          query = {
            lang: lang,
            currencyLocal: currency,
            offerId: offerID
          };
          _context7.next = 10;
          return (0, _effects.call)(_jsonApi.getToursBookCalculate, tokenAsObject, query, body);
        case 10:
          _yield$call = _context7.sent;
          price = _yield$call.price;
          rate = _yield$call.rate;
          return _context7.abrupt("return", {
            price: price,
            rate: rate
          });
        case 14:
        case "end":
          return _context7.stop();
      }
    }, _callee4);
  })();
}
function recalculateOfferPriceByOwnBooking(_ref7) {
  var services = _ref7.services,
    offerID = _ref7.offerID,
    currency = _ref7.currency,
    bookingEntity = _ref7.bookingEntity;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var transport, offer, _yield$call2, price, rate;
    return _regeneratorRuntime().wrap(function _callee5$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          transport = (0, _config.getOnRecalculateBookingServices)();
          if (!transport) {
            _context8.next = 11;
            break;
          }
          _context8.next = 4;
          return (0, _effects.select)(function (state) {
            return (0, _selectors3.getOffer)()(state, {
              offerID: offerID
            });
          });
        case 4:
          offer = _context8.sent;
          _context8.next = 7;
          return (0, _effects.call)(transport, {
            services: services,
            offer: offer,
            currency: currency,
            bookingEntity: bookingEntity
          });
        case 7:
          _yield$call2 = _context8.sent;
          price = _yield$call2.price;
          rate = _yield$call2.rate;
          return _context8.abrupt("return", {
            price: price,
            rate: rate
          });
        case 11:
          throw new Error('getOnRecalculateBookingServices not found!');
        case 12:
        case "end":
          return _context8.stop();
      }
    }, _callee5);
  })();
}
function recalculateOfferPriceSaga(_ref8) {
  var _ref8$payload = _ref8.payload,
    offerID = _ref8$payload.offerID,
    queryID = _ref8$payload.queryID,
    bookingEntity = _ref8$payload.bookingEntity;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var currency, services, _yield$select2, hasOwnBookingServices, _yield$call3, price, rate, activeServices;
    return _regeneratorRuntime().wrap(function _callee6$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.put)((0, _actions2.register)(_constants.RECALCULCATE_OFFER_PRICE, {
            loading: true,
            error: false,
            completed: false
          }));
        case 2:
          _context9.next = 4;
          return (0, _effects.select)(function (state) {
            return (0, _selectors2.getQueryParam)(state, {
              paramName: _fn.QUERY_PARAMS.CURRENCY,
              queryID: queryID
            });
          });
        case 4:
          currency = _context9.sent;
          _context9.next = 7;
          return (0, _effects.select)(function (state) {
            return (0, _selectors6.getActiveBookingServices)(state, {
              offerID: offerID,
              currency: currency
            });
          });
        case 7:
          services = _context9.sent;
          _context9.next = 10;
          return (0, _effects.select)(_selectors5.getBookingOperator);
        case 10:
          _yield$select2 = _context9.sent;
          hasOwnBookingServices = _yield$select2.hasOwnBookingServices;
          _context9.prev = 12;
          _context9.next = 15;
          return (0, _effects.call)(hasOwnBookingServices ? recalculateOfferPriceByOwnBooking : recalculateOfferPriceByDefault, {
            services: services,
            offerID: offerID,
            currency: currency,
            bookingEntity: bookingEntity
          });
        case 15:
          _yield$call3 = _context9.sent;
          price = _yield$call3.price;
          rate = _yield$call3.rate;
          _context9.next = 20;
          return (0, _effects.put)((0, _actions3.setRecalculatedPrice)({
            price: price,
            rate: rate
          }));
        case 20:
          _context9.next = 22;
          return (0, _effects.select)(_selectors6.getActiveServices);
        case 22:
          activeServices = _context9.sent;
          _context9.next = 25;
          return (0, _effects.put)((0, _actions3.setLastRecalculatedActiveServices)(activeServices));
        case 25:
          _context9.next = 31;
          break;
        case 27:
          _context9.prev = 27;
          _context9.t0 = _context9["catch"](12);
          _context9.next = 31;
          return (0, _effects.put)((0, _actions2.update)(_constants.RECALCULCATE_OFFER_PRICE, {
            error: true
          }));
        case 31:
          _context9.prev = 31;
          _context9.next = 34;
          return (0, _effects.put)((0, _actions2.update)(_constants.RECALCULCATE_OFFER_PRICE, {
            loading: false,
            completed: true
          }));
        case 34:
          _context9.next = 36;
          return (0, _effects.put)((0, _actions3.setShouldRecalculatePrice)(false));
        case 36:
          return _context9.finish(31);
        case 37:
        case "end":
          return _context9.stop();
      }
    }, _callee6, null, [[12, 27, 31, 37]]);
  })();
}
function onUpdateActiveCountOfBookingServicesSaga(_ref9) {
  var _ref9$payload = _ref9.payload,
    serviceID = _ref9$payload.serviceID,
    touristIds = _ref9$payload.touristIds,
    type = _ref9.type;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var offer, isNeedRecalculatePrice, service, recalculatedPrice, nextRecalculatedPrice;
    return _regeneratorRuntime().wrap(function _callee7$(_context0) {
      while (1) switch (_context0.prev = _context0.next) {
        case 0:
          _context0.next = 2;
          return (0, _effects.select)(_selectors5.getBootstrapOffer);
        case 2:
          offer = _context0.sent;
          _context0.next = 5;
          return (0, _effects.select)(function (state) {
            return (0, _ramda.converge)(function (activeServices, lastRecalculatedActiveServices) {
              return !(0, _ramda.equals)(activeServices, lastRecalculatedActiveServices);
            }, [_selectors6.getActiveServices, _selectors6.getLastRecalculatedActiveServices])(state);
          });
        case 5:
          isNeedRecalculatePrice = _context0.sent;
          if (!isNeedRecalculatePrice) {
            _context0.next = 11;
            break;
          }
          _context0.next = 9;
          return (0, _effects.put)((0, _actions3.setShouldRecalculatePrice)(true));
        case 9:
          _context0.next = 13;
          break;
        case 11:
          _context0.next = 13;
          return (0, _effects.put)((0, _actions3.setShouldRecalculatePrice)(false));
        case 13:
          _context0.next = 15;
          return (0, _effects.select)(function (state) {
            return (0, _ramda.find)(function (_ref0) {
              var id = _ref0.id;
              return id === serviceID;
            }, (0, _selectors.getBookingServicesByOffer)(state, {
              currency: offer.currencyLocal,
              offerID: offer.id
            }));
          });
        case 15:
          service = _context0.sent;
          _context0.next = 18;
          return (0, _effects.select)(_selectors6.getRecalculatedPrice);
        case 18:
          recalculatedPrice = _context0.sent;
          if (!(recalculatedPrice && !(0, _ramda.isEmpty)(service.price))) {
            _context0.next = 23;
            break;
          }
          nextRecalculatedPrice = (0, _ramda.mergeWith)(function (priceA, priceB) {
            if (type === _actions3.detachService.toString()) {
              return Math.abs(priceA - priceB);
            }
            if (type === _actions3.setActiveServicesById.toString()) {
              return (0, _ramda.isEmpty)(touristIds) ? priceA - priceB : priceA + priceB;
            }
            return priceA + priceB;
          }, recalculatedPrice, service.price);
          _context0.next = 23;
          return (0, _effects.put)((0, _actions3.updateRecalculatedPrice)(nextRecalculatedPrice));
        case 23:
        case "end":
          return _context0.stop();
      }
    }, _callee7);
  })();
}
function bookingServicesRootSaga() {
  return _regeneratorRuntime().wrap(function bookingServicesRootSaga$(_context10) {
    while (1) switch (_context10.prev = _context10.next) {
      case 0:
        _context10.next = 2;
        return (0, _effects.takeEvery)(_actions3.showBookingServices, onShowBookingServicesSaga);
      case 2:
        _context10.next = 4;
        return (0, _effects.takeEvery)(_actions3.hideBookingServices, onHideBookingServicesSaga);
      case 4:
        _context10.next = 6;
        return (0, _effects.takeEvery)(_actions3.updateBookingServices, updateBookingServicesSaga);
      case 6:
        _context10.next = 8;
        return (0, _effects.takeEvery)(_actions3.recalculateOfferPrice, recalculateOfferPriceSaga);
      case 8:
        _context10.next = 10;
        return (0, _effects.takeEvery)([_actions3.applyService, _actions3.detachService, _actions3.setActiveServicesById, _actions3.detachActiveServicesById], /*#__PURE__*/_regeneratorRuntime().mark(function onUpdateActiveCountOfServicesGuardSaga(action) {
          var _yield$select3, error;
          return _regeneratorRuntime().wrap(function onUpdateActiveCountOfServicesGuardSaga$(_context1) {
            while (1) switch (_context1.prev = _context1.next) {
              case 0:
                _context1.next = 2;
                return (0, _effects.select)(_selectors6.getRecalculateOfferPriceUI);
              case 2:
                _yield$select3 = _context1.sent;
                error = _yield$select3.error;
                if (error) {
                  _context1.next = 7;
                  break;
                }
                _context1.next = 7;
                return (0, _effects.call)(onUpdateActiveCountOfBookingServicesSaga, action);
              case 7:
              case "end":
                return _context1.stop();
            }
          }, onUpdateActiveCountOfServicesGuardSaga);
        }));
      case 10:
      case "end":
        return _context10.stop();
    }
  }, _marked4);
}